import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import {
  colorAccessibleGreen,
  colorTelusPurple
} from '@tds/core-colours/dist/index.cjs';

import { Text } from '../css';
import { Box } from '../../../design/css';

const OrderComments = ({ data }) => {
  return (
    <>
      {data.map((comment, index) => {
        const {
          text,
          createdAt,
          user: { first_name: firstName, last_name: lastName }
        } = comment;
        const userName = `${firstName.concat(' ', lastName)}: `;
        const commentDate = moment(createdAt).format(
          'dddd, MMMM Do YYYY, h:mm:ss a'
        );
        const key = `comment${index}`;

        return (
          text && (
            <Box key={key} pt="20">
              <Text bold color={colorTelusPurple}>
                {userName}
              </Text>
              <Text fontWeight="500">{`${text} - `}</Text>
              <Text bold color={colorAccessibleGreen}>
                {commentDate}
              </Text>
            </Box>
          )
        );
      })}
    </>
  );
};

OrderComments.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string,
      createdAt: PropTypes.string,
      user: PropTypes.shape({
        first_name: PropTypes.string,
        last_name: PropTypes.string
      })
    })
  ).isRequired
};

export default OrderComments;
